// extracted by mini-css-extract-plugin
export default {"wrapper":"SongMaterials_wrapper__bRaoc"};